import NavSlot from "@/components/navigation/links";
import { Outlet } from "react-router-dom";
import SupportMyTickets from "./my-tickets";
import SupportAllTickets from "./all-tickets";
import SupportAssignedTickets from "./assigned";

export const supportNavItems = [
  {
    label: "All Tickets",
    value: "all-tickets",
    path: "/support/all-tickets",
    element: SupportAllTickets,
  },
  {
    label: "My Tickets",
    value: "my-tickets",
    path: "/support/my-tickets",
    element: SupportMyTickets,
  },
  {
    label: "Assigned",
    value: "assigned-tickets",
    path: "/support/assigned-tickets",
    element: SupportAssignedTickets,
  },
];

const SupportLayout = () => {
  return (
    <div className="flex-1 overflow-auto relative mt-10">
      <div className="fixed top-12 md:top-16 w-full bg-white z-1">
        <NavSlot navItems={supportNavItems} />
      </div>
      <Outlet />
    </div>
  );
};

export default SupportLayout;
